<template>
	<v-app>
		<v-content>

			<router-view></router-view>

		</v-content>
		<v-dialog
			v-model="dialogLoading.open"
			persistent
			width="500">
			<v-card color="primary" dark>
				<v-card-text class="pa-8">
					<v-progress-linear
						indeterminate
						color="white">
					</v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogDone.open"
			width="500">
			<v-card color="primary" dark>
				<v-card-text class="px-5 py-1">
					<v-container class="pa-0" grid-list-xs >
						<v-row justify="center">
							<v-col cols="2" class="text-center">
								<v-icon x-large dark>done</v-icon>
							</v-col>
							<v-col class="pa-2 text-left" :class="dialogDone.messageClass" v-if="dialogDone.message">
								<span class="headline" v-text="dialogDone.message"></span>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogNotify.open"
			max-width="600"
			persistent>
    		<v-card>
        		<v-card-title class="headline">
					{{ dialogNotify.title }}
				</v-card-title>

				<v-card-text>
					<span
						v-html="dialogNotify.message"
						class="text--primary">
					</span>
		        </v-card-text>

	        	<v-card-actions class="pa-4">
					<v-btn color="primary" @click="dialogNotifyHide">
	            		Закрыть
	          		</v-btn>
	        	</v-card-actions>
	      	</v-card>
	    </v-dialog>
		<v-dialog
			v-model="dialogConfirm.open"
			max-width="600"
			ref="confirm"
			persistent>
    		<v-card>
        		<v-card-title class="headline">
					{{ dialogConfirm.title }}
				</v-card-title>

		        <v-card-text>
					<span
						v-html="dialogConfirm.message"
						class="text--primary">
					</span>
		        </v-card-text>

	        	<v-card-actions class="pa-4">
					<v-btn color="primary" @click="dialogConfirmAccept">
						{{ dialogConfirm.btnAcceptText }}
					</v-btn>
					<v-btn color="primary" @click.native="dialogConfirmDeny">
						{{ dialogConfirm.btnDenyText }}
					</v-btn>
	        	</v-card-actions>
	      	</v-card>
	    </v-dialog>
	</v-app>
</template>

<script>
	export default {
		data: () => ({
		}),
		computed: {
			admin() {
				return this.$store.getters.admin
			},
			loggedIn() {
				return this.$store.getters.loggedIn
			},
			dialogDone() {
				return this.$store.getters.dialogDone
			},
			dialogLoading() {
				return this.$store.getters.dialogLoading
			},
			dialogNotify() {
				return this.$store.getters.dialogNotify
			},
			dialogConfirm() {
				return this.$store.getters.dialogConfirm
			},
		},
		created() {
		},
		methods: {
			dialogNotifyHide () {
				this.$store.dispatch('dialogNotifyHide')
			},
			dialogConfirmAccept () {
				this.$store.dispatch('dialogConfirmAccept')
			},
			dialogConfirmDeny () {
				this.$store.dispatch('dialogConfirmDeny')
			},
		}
	}
</script>

<style>
</style>
